<template>
  <div class="introduction">
    <ucar-title>{{title}}</ucar-title>
    <ucar-img-header type="introduction" :has-car="type !== 'nocar'"></ucar-img-header>
    <introduction-header title="无车加入" desc="平台提供合规车辆，多种车型可租可买" v-if="type === 'nocar'"></introduction-header>
    <introduction-header title="带车加入" desc="大平台有保障，时间自由，奖励丰厚" v-else></introduction-header>
    <div class="introduction-block introduction-method" v-if="type === 'nocar'">
      <h3>无车加入方式</h3>
      <ul>
        <li v-if="vuexCurrentCity.rentCar">
          <h4>超低价租车</h4>
          <p>内部价格租车，无车也能开专车</p>
          <p class="link" v-if="ableShowRentCar" @click="goShowcase('rent')">查看可租车型和价格</p>
        </li>
        <li v-if="vuexCurrentCity.buyCar">
          <h4>低首付购车</h4>
          <p>多种车型优惠购，赚钱同时赚辆车</p>
          <p class="link" v-if="ableShowSaleCar" @click="goShowcase('sale')">查看可买车型和价格</p>
        </li>
        <li v-if="vuexCurrentCity.selfOperated">
          <h4>无车全职加入</h4>
          <p>大平台有保障，0投资高回报</p>
        </li>
      </ul>
    </div>
    <div class="introduction-block introduction-advantage" v-else>
      <h3>带车加入优势</h3>
      <ul>
        <li>
          <img src="../../assets/introduction-advantage-1.png" />
          <p>订单单价高</p>
        </li>
        <li>
          <img src="../../assets/introduction-advantage-2.png" />
          <p>工作日可提现</p>
        </li>
        <li>
          <img src="../../assets/introduction-advantage-3.png" />
          <p>客户素质高</p>
        </li>
      </ul>
    </div>
    <introduction-require title="司机要求" :list="vuexCurrentCity.driverRequire"></introduction-require>
    <introduction-require title="车辆要求" :list="vuexCurrentCity.carRequire" v-if="type !== 'nocar'"></introduction-require>
    <introduction-process title="招募流程" :list="process"></introduction-process>
    <introduction-contact title="报名咨询" :cityId="vuexCurrentCity.cityId" v-if="vuexCurrentCity.cityId!==''"></introduction-contact>
    <ucar-submit v-if="mode === 'normal'" @click.native="goLogin">立即报名</ucar-submit>
  </div>
</template>

<style lang="stylus" scoped>
@import "../../styles/variable.styl";

.introduction {

  .introduction-block {
    margin-bottom: 20px;
    line-height: 1;
    background-color: #fff;
    color: $ucar_font_color;

    h2,
    h3 {
      text-align: center;
    }

    h2 {
      font-size: $ucar_font_h3;
    }

    h3 {
      font-size: $ucar_font_h4;
      font-weight: bold;
    }
  }

  .introduction-method {
    padding: 40px 60px;

    h3 {
      margin-bottom: 40px;
    }

    ul {
      padding-left: 30px;

      li {
        position: relative;
        margin-bottom: 40px;

        &:last-child {
          margin-bottom: 0;
        }

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: -30px;
          height: 32px;
          width: 10px;
          background-color: $ucar_price_color;
        }

        h4 {
          font-size: $ucar_font_h4;
          margin-bottom: 20px;
        }

        p {
          font-size: $ucar_font_h6;
          color: $ucar_alert_color;
          margin-bottom: 20px;

          &:last-child {
            margin-bottom: 0;
          }

          &.link {
            color: $ucar_price_color;

            &::after {
              content: ">";
              display: inline-block;
              margin-left: 6px;
            }
          }
        }
      }
    }
  }

  .introduction-advantage {
    padding: 40px 30px;

    h3 {
      margin-bottom: 50px;
    }

    ul {
      display: flex;

      li {
        flex: 1 1 33%;
        display: inline-flex;
        flex-flow: column nowrap;
        align-items: center;

        img {
          height: 75px;
          width: 75px;
          margin-bottom: 30px;
        }

        p {
          text-align: center;
          font-size: $ucar_font_h6;
          font-weight: bold;
        }
      }
    }
  }
}
</style>

<script>
import { regProcessForNocar, regProcessForHascar, loginStatus } from '../../utils/constants'
import introductionHeader from '../../components/introduction-header'
import introductionRequire from '../../components/introduction-require'
import introductionProcess from '../../components/introduction-process'
import introductionContact from '../../components/introduction-contact'

export default {
  data () {
    return {
      title: '...',
      mode: 'normal',
      type: 'nocar',
      process: []
    }
  },
  components: {
    introductionHeader,
    introductionRequire,
    introductionProcess,
    introductionContact
  },
  computed: {
    ableShowRentCar () {
      return this.vuexRentData.vehiclePrice.filter(item => item.cityId === this.vuexCurrentCity.id).length > 0
    },
    ableShowSaleCar () {
      return this.vuexSaleData.vehiclePrice.filter(item => item.cityId === this.vuexCurrentCity.id).length > 0
    }
  },
  methods: {
    goShowcase (target) {
      this.$router.push(`/showcase/${target}`)
    },
    goLogin () {
      this.setVuexDriverType('1')
      this.type === 'hascar' ? this.setVuexOwnCarJoin(true) : this.setVuexOwnCarJoin(false)
      if (this.loginStatus === loginStatus.fillInfo) {
        this.vuexNewRecruit ? this.$router.push('/new-driver-info') : this.$router.push('/driver-info')
      } else {
        this.$router.push('/login?joinMode=join')
      }
    }
  },
  created () {
    this.type = this.$route.params.type
    if (this.$route.query.mode) this.mode = this.$route.query.mode
    if (this.type !== 'nocar') {
      this.title = '带车加入'
      this.process = regProcessForHascar
    } else {
      this.title = '无车加入'
      this.process = regProcessForNocar
    }
  }
}
</script>
